import React from 'react';
import { JobDetail, ErrorBoundaryUI } from '@indeed/messaging-react';

interface JobDetailContainerProps {
    conversationId: string | undefined;
    jobKey: string | undefined;
    isSinglePane: boolean;
    navigationHandlers: {
        onBackClick: () => void;
    };
}

const JobDetailContainer: React.FC<JobDetailContainerProps> = ({
    conversationId,
    jobKey,
    isSinglePane,
    navigationHandlers,
}) => {
    const errorFallback = (
        <div
            style={{
                padding: '16px',
                border: '1px solidrgb(9, 8, 8)',
                borderRadius: '4px',
                backgroundColor: '#f5f5f5',
                color: '#666',
            }}
        >
            Unable to load job details. Please try again later.
        </div>
    );

    if (!conversationId && !jobKey) {
        // TODO: Render the no job details available UI
        return null;
    }

    return (
        <ErrorBoundaryUI
            fallback={errorFallback}
            testId="indeed-messaging--job-detail-error-boundary"
        >
            <JobDetail
                conversationId={conversationId}
                jobKey={jobKey}
                showDescription={false} // Originally truncated in the old JobDetail component
                onBackClick={isSinglePane ? navigationHandlers.onBackClick : undefined}
            />
        </ErrorBoundaryUI>
    );
};

export default JobDetailContainer;
